<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>To my mother</i>,</span></p>
<p class="ded1"><span><i>who is no longer with us</i></span></p>
<p class="ded1"><span><i>but who I know</i></span></p>
<p class="ded1"><span><i>is smiling down from heaven</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6d4a2559